import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import backgroundDetailContact from '../../../assets/backgroundDetailContact.svg';
import backgroundDetailContactMobile from '../../../assets/backgroundDetailContactMobile.svg';
import iconEditContact from '../../../assets/iconEditContact.svg';
import userImageProfile from '../../../assets/userImageProfile.svg'
import { useWindowWidth } from "@react-hook/window-size";
import ActividadDelAsesor from "./ActividadDelAsesor.jsx"

const DetailAsesor =
  ({
    setModalAsignarContactos,
    selectedAsesor,
    getReporteActividadAsesor,
    user,
  }) => {

    const onlyWidth = useWindowWidth();

    return (
      <DivBoxContainer>
        <DivContainer>

          <DivContentImage src={onlyWidth > 1100 ? backgroundDetailContact : backgroundDetailContactMobile} />

          {
            user.type !== "Admin" && user.type !== "Supervisor" ?
              null :
              <ContainerBtnEditar src={iconEditContact} />
          }

          <DivColumnRelative>
            <ImageProfile src={selectedAsesor?.imagen_profile || userImageProfile} />
            <TextNameUser>
              <b>{selectedAsesor?.name} {selectedAsesor.lastname}</b>
            </TextNameUser>

          </DivColumnRelative>

        </DivContainer>

        <DivColumn1>

          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignContent: 'flex-start',
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
            }}>
              <Text1 style={{
                fontSize: '16px',
                margin: '0px 0px 8px 0px'
              }}><b>Datos de asesor</b></Text1>
              <Text1><b>Teléfono: </b>{selectedAsesor.phone}</Text1>
              <Text1><b>Email:</b> {selectedAsesor.email}</Text1>
              <Text1><b>Sucursal:</b> {selectedAsesor.partido_localidad}</Text1>
            </div>

          </div>

          <Text1 style={{
            fontSize: '16px',
            margin: '0px 0px 8px 0px'
          }}><b>Contactos Asignados</b></Text1>

          <ActividadDelAsesor
            getReporteActividadAsesor={getReporteActividadAsesor}
            selectedAsesor={selectedAsesor}
            user={user}
          />
        </DivColumn1>

      </DivBoxContainer>

    );
  };

export default DetailAsesor;

const DivBoxContainer = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: -webkit-fill-available;
  height: auto;
  min-height: 130vh;
`;

const ContainerBtnEditar = styled.img`
  position: relative;
  height: 25px;
  font-family: 'Montserrat',sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  background-color: #00000054;
  left: unset;
  padding: 5px;
  top: -135px;
  margin-right: 16px;
  margin-left: 93%;
  width: -webkit-fill-available;
  border-radius: 4px;
  filter: drop-shadow(0.2px 0.2px 0px #00000099);
  text-align: center;
  cursor:pointer;
  transition: all 0.5s;
  &:hover {
    filter: invert(1)
  }
`;

const TextNameUser = styled.span`
  width: auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 22px;
  color: #003049;

`;

const DivColumn1 = styled.div`
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content:center;
  width: -webkit-fill-available;
  margin: 65px 0% 0% 0%;
  padding: 16px 16px;
  border-radius:8px;
  background-color:#FFFFFF;
  gap:16px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
`;

const DivColumnRelative = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: auto;
  z-index: 2;
  top: -80px;
  align-self: flex-start;
  margin-left: 16px;

  @media only screen and (min-width:1100px) and (max-width:1380px) {
    zoom:0.85
  }

  @media only screen and (min-width:0px) and (max-width:1100px) {
    margin-left: 0px;
    align-self: center;
    zoom:0.85
  }
`;

const DivContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: -webkit-fill-available;
  height: 180px;
  max-height: 180px;
  margin: 0px 0%
  gap:0px;
`;

const DivContentImage = styled.img`
  height: 150px;
  width: 100%;
  background-color: #FFFFFF;
  object-fit: cover;
  border-radius: 8px 8px 8px 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
`;

const ImageProfile = styled.img`
  height: 100px;
  width: 100px;
  background-color: #FFFFFF;
  object-fit: cover;
  border-radius: 100%;
  filter: drop-shadow(2px 4px 6px #cecece);
`;

const Text1 = styled.span`
  width: auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #003049;

`;